<script setup lang="ts">
import { useSearchContext } from '../composables/searchContext';
const search = useSearchContext();
</script>

<template>
  <div v-if="search.isLoading.value || search.isCheckoutLoading.value" id="updateProgress-loading" role="status" aria-live="polite">
    <div class="k-overlay"></div>
    <div class="product-serchresults loaderdiv" aria-label="Loading search results"><div></div><div></div><div></div><div></div></div>
  </div>
</template>
